import Vue from 'vue'
import { MessageBox } from 'element-ui'
import router from '@/router'
import store from '@/store'
import AppSettings from '@/config/app-config'

const NEXT_UPDATE_TICK = 12 * 60 * 60 * 1000
const LOGIN_PATH = '/login'
const ANONYMOUS_URL = ['/api/home/login']
const UPDATE_TOKEN_URL = '/api/home/update-token'

//Vue.use(VueResource);
//Vue.http.headers.common['Authorization'] = 'JWT ' + store.state.user.jwtToken;
//Vue.http.options.emulateJSON = true;
export default {
  get: async (url, urlParams) => {
    return http(url, undefined, urlParams, (u, p, op) => Vue.http.get(u, op))
  },

  post: async (url, params, urlParams) => {
    return http(url, params, urlParams, (u, p, op) => Vue.http.post(u, p, op))
  }
}

async function http(url, params, urlParams, action) {
  if (ANONYMOUS_URL.indexOf(url) < 0 && !(await beforeAction())) return;
  return new Promise((resolve, reject) => {
    action(url, params, createOption(urlParams)).then(
      res => processResponse(res, resolve),
      res => processResponse(res, resolve))
  })
}

function beforeAction() {
  const loginInfo = store.state.loginInfo
  const loginTime = loginInfo && loginInfo.loginTime
  const now = new Date().getTime()
  // 上一次更新token是10分钟以前，进行token更新
  if (loginTime && loginTime + NEXT_UPDATE_TICK < now) {
    const options = { headers: {'Authorization': 'Bearer ' + loginInfo.jwtToken} }
    return new Promise((resolve, reject) => {
      Vue.http.post(UPDATE_TOKEN_URL + '?t=' + now, null, options).then(
        res => {
          store.commit('updateToken', res.data.data.jwtToken)
          resolve(true)
        }, res => {
          if (res.status == 401) {
            router.push(LOGIN_PATH)
            resolve(false)
          } else {
            MessageBox.alert(`网络访问错误: ${res.status} ${res.statusText}`, AppSettings.alertTitle).then(() => {
              resolve(false)
            })
          }
        })
    })
  } else {
    return true
  }
}

// 在http请求头上加入jwt令牌
function createOption(urlParams) {
  const option = {params: urlParams}
  const loginInfo = store.state.loginInfo
  const jwtToken = loginInfo && loginInfo.jwtToken
  if (jwtToken != undefined) {
    option.headers = {'Authorization': 'Bearer ' + jwtToken}
  }
  return option
}

// 处理返回结果，有消息文本则显示提示消息，把异常包装成普通结果
function processResponse(res, resolve) {
  if (res.status != 200) {
    res.data = {status: -1, message: `网络访问错误: ${res.status} ${res.statusText}`}
    if (res.status == 401) {
      router.push(LOGIN_PATH)
      resolve(res)
    } else {
      MessageBox.alert(res.data.message, AppSettings.alertTitle).then(() => resolve(res))
    }
  } else {
    if (res.data) {
      const msg = res.data.message
      if (msg) {
        if (res.data.status == 0) {
          MessageBox.alert(msg, AppSettings.alertTitle).then(() => resolve(res))
        } else {
          MessageBox.alert(msg, AppSettings.alertTitle).then(() => resolve(res))
        }
      }
    }
  }
  resolve(res)
}




// WEBPACK FOOTER //
// ./src/api/http.js